/**
 *  @class
 *  @function TabbedShowcase
 *  Tabs where every tab swaps the big image and the content panel.
 */
if (!customElements.get('tabbed-showcase')) {
  class TabbedShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.tabbed-showcase__tab'));
      this.panels = Array.from(this.querySelectorAll('.tabbed-showcase__panel'));
      this.images = Array.from(this.querySelectorAll('.tabbed-showcase__image'));
      this.tablist = this.querySelector('.tabbed-showcase__tabs');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.tabs.indexOf(event.target);
          if (index < 0) {
            index = this.images.indexOf(event.target);
          }
          if (index >= 0) {
            this.select(index);
          }
        });
      }
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) {
        return;
      }
      event.preventDefault();
      this.select(next, true);
    }

    select(index, focus) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      this.images.forEach((image, i) => {
        image.classList.toggle('is-active', i === index);
      });
      this.setAttribute('selected-index', index);

      const tab = this.tabs[index];
      if (tab && this.tablist) {
        // Keep the active tab visible when the tab bar scrolls (mobile).
        const left = tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2;
        this.tablist.scrollTo({ left: left, behavior: 'smooth' });
        if (focus) {
          tab.focus({ preventScroll: true });
        }
      }
    }
  }
  customElements.define('tabbed-showcase', TabbedShowcase);
}
